// resetAliasSlice.js
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { fetchDeconnexion } from "../connexion/connexionSlice";
import { API_URL } from "../../Constants";
import Cookies from "js-cookie";

export const initialState = {
  loading: false,
  hasErrors: false,
  success: false,
  message: "",
};

const resetAliasSlice = createSlice({
  name: "resetAlias",
  initialState,
  reducers: {
    resetAliasStart: (state) => {
      state.loading = true;
      state.hasErrors = false;
      state.success = false;
      state.message = "";
    },
    resetAliasSuccess: (state, { payload }) => {
      state.loading = false;
      state.hasErrors = false;
      state.success = true;
      state.message = payload.message || "Alias modifié avec succès !";
    },
    resetAliasFailure: (state, { payload }) => {
      state.loading = false;
      state.hasErrors = true;
      state.success = false;
      state.message =
        payload.message || "Erreur lors de la modification de l'alias.";
    },
    resetAliasClear: (state) => {
      state.loading = false;
      state.hasErrors = false;
      state.success = false;
      state.message = "";
    },
  },
});

export const {
  resetAliasStart,
  resetAliasSuccess,
  resetAliasFailure,
  resetAliasClear,
} = resetAliasSlice.actions;

export const resetAliasSelector = (state) => state.resetAlias;

export default resetAliasSlice.reducer;

export function fetchResetAlias({ id, newAlias }) {
  return async (dispatch, getState) => {
    dispatch(resetAliasStart());
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": getState().connexion.utilisateur.csrf_token,
        },
        withCredentials: true,
      };

      const payload = { id, alias: newAlias };

      // Ici, l'URL est celle qui met à jour l'utilisateur dans l'administration.
      // Si vous préférez un endpoint dédié à l'alias, modifiez l'URL en conséquence.
      const response = await axios.patch(
        `${API_URL}/compte/admin/utilisateur`,
        payload,
        config
      );

      dispatch(resetAliasSuccess(response.data));
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(fetchDeconnexion());
        }
        dispatch(resetAliasFailure(error.response.data));
      } else {
        dispatch(resetAliasFailure({ message: "Erreur réseau" }));
      }
    }
  };
}
